import React, { memo } from 'react';

import { Container } from '~/Components/Grid/Grid';
import Statistics from '~/Components/Statistics/Statistics';
import { getStatisticsData } from '~/utils/statistics';

import styles from './ProfileStatistics.scss';

export interface ProfileStatisticsState {
  account?: Account;
  battleType: StatBattleType;
  statistics: BattleStat;
  seasonPickerVisible: boolean;
  seasonNumber?: string;
}

const ProfileStatistics = (props: any) => {
  const data = getStatisticsData(props.statistics);

  return (
    <Container className={styles.wrapper}>
      <Statistics data={data} />
    </Container>
  );
};

export default memo(ProfileStatistics);
